import React, { createContext, useContext, useState, useEffect } from 'react';
import { axiosInstance as axios } from './AuthContext';

const API = '';

const FamilyThemeContext = createContext(null);

export function FamilyThemeProvider({ children }) {
  const [activeFamily, setActiveFamily] = useState(null);
  const [ancestralColors, setAncestralColors] = useState(null);

  // Load active family from localStorage on mount
  useEffect(() => {
    const savedFamilyId = localStorage.getItem('activeFamilyId');
    if (savedFamilyId) {
      fetchFamilyTheme(savedFamilyId);
    }
  }, []);

  const fetchFamilyTheme = async (familyId) => {
    try {
      const response = await axios.get(`${API}/api/families/${familyId}`, {
        withCredentials: true
      });
      const family = response.data;
      setActiveFamily(family);
      setAncestralColors(family.ancestral_colors || null);
      localStorage.setItem('activeFamilyId', familyId);
    } catch (error) {
      console.error('Error fetching family theme:', error);
    }
  };

  const setActiveFamilyId = (familyId) => {
    if (familyId) {
      fetchFamilyTheme(familyId);
    } else {
      setActiveFamily(null);
      setAncestralColors(null);
      localStorage.removeItem('activeFamilyId');
    }
  };

  const updateColors = (colors) => {
    setAncestralColors(colors);
  };

  // Generate CSS variables for the theme
  const themeStyles = ancestralColors ? {
    '--family-primary': ancestralColors.primary || '#3B82F6',
    '--family-secondary': ancestralColors.secondary || '#8B5CF6',
    '--family-tertiary': ancestralColors.tertiary || ancestralColors.primary || '#3B82F6',
  } : {};

  return (
    <FamilyThemeContext.Provider value={{
      activeFamily,
      ancestralColors,
      setActiveFamilyId,
      updateColors,
      themeStyles,
    }}>
      <div style={themeStyles}>
        {children}
      </div>
    </FamilyThemeContext.Provider>
  );
}

export function useFamilyTheme() {
  const context = useContext(FamilyThemeContext);
  if (!context) {
    throw new Error('useFamilyTheme must be used within a FamilyThemeProvider');
  }
  return context;
}

export default FamilyThemeContext;
